import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/door-access/control-hubs/door-hub-mini.png";
import type { Product } from "../../types";
import { doorAccessControlHubs } from "../product-list-groups/doorAccessControlHubs";
import {
  accessPowerMethod,
  inputTerminals,
  outputRelays,
  poePorts,
  powerRedundancy,
} from "../properties";

export const doorHubMini: Product = {
  id: "doorHubMini",
  productTitle: "Door Hub Mini",
  description: "doorHubMini.description",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.DoorAccess}/ua-hub-door-mini`,
  ],
  storePathParts: {
    category: UniFiChildCategorySlug.DoorAccessHub,
    productSlug: "ua-hub-door-mini",
  },
  productListGroup: doorAccessControlHubs,
  image: { src: image, width: 200, height: 160 },
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '113 x 66 x 27.6 mm\n(4.4 x 2.6 x 1.1")',
      },
    },
    {
      propertyId: outputRelays.id,
      value: {
        type: "translation",
        value: "doorHubMini.outputRelays",
      },
    },
    {
      propertyId: inputTerminals.id,
      value: {
        type: "translation",
        value: "doorHubMini.inputTerminals",
      },
    },
    {
      propertyId: poePorts.id,
      value: {
        type: "translation",
        value: "doorHubMini.poePorts",
      },
    },
    {
      propertyId: accessPowerMethod.id,
      value: { type: "string", value: "PoE++" },
    },
    {
      propertyId: powerRedundancy.id,
      value: { type: "boolean", value: false },
    },
  ],
};
